// extracted by mini-css-extract-plugin
export default {"errorWrapper":"error_errorWrapper__8FXiT","warningIcon":"error_warningIcon__FkUmb"};